<template>
  <div class="order-status-faq" v-if="displayFaqs">
    <div class="container">
      <div class="row">
        <div class="col-8">
          <div class="faded-intro">
            <p>{{ faqsPreTitle }}</p>
          </div>

          <h2>{{ faqsHeading }}</h2>

          <p>{{ faqsDescription }}</p>


          <div class="accordion" id="faqAccordion" v-if="product.questions">
            <div class="accordion-row" v-for="(question, index) in product.questions">
              <div id="faq-1" class="card-header">
                <h2 class="mb-0">
                  <button type="button" data-bs-toggle="collapse" :data-bs-target="`#faq-${index}-content`"
                    aria-expanded="false"
                    :aria-controls="`faq-${index}-content`" class="btn">
                    <span>{{ question.question }}</span>
                  </button>
                </h2>
              </div>
              <div :id="`faq-${index}-content`" :aria-labelledby="`faq-${index}`"
                data-bs-parent="#faqAccordion"
                class="collapse" style="">
                <div class="card-body">
                  <p v-html="question.answer"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "order-status-faq",
  props: [
    'order',
    'product'
  ],
  computed: {
    displayFaqs() {
      return this.product?.faqs_display_faqs;
    },
    faqsPreTitle() {
      return this.product?.faqs_pre_title ? this.product.faqs_pre_title : '';
    },
    faqsHeading() {
      return this.product?.faqs_heading ? this.product.faqs_heading : '';
    },
    faqsDescription() {
      return this.product?.faqs_description ? this.product.faqs_description : '';
    }
  }
}
</script>

<style scoped lang="scss">

.order-status-faq {
  padding: 4rem 0;
  background-color: whitesmoke;

  .faded-intro {
    color: #B3B0AB;
  }
}
</style>
